import { createSlice } from "@reduxjs/toolkit";
import {
  createSurname,
  deleteSurname,
  getSurname,
  undoDeleteSurname,
} from "./surname.api";

const surnameSlice = createSlice({
  name: "surname",
  initialState: {
    surname: { data: [] },
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSurname.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSurname.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(createSurname.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    // GET Banner FILTER WISE DATA
    builder.addCase(getSurname.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSurname.fulfilled, (state, action) => {
      state.loading = false;
      state.surname = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getSurname.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteSurname.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteSurname.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.surname.data) {
        state.surname.data = state.surname.data.filter((surname) => {
          return surname._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.surname.data is not an array:",
          state.surname.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteSurname.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteSurname.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteSurname.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.surname.data) {
        state.surname.data = state.surname.data.filter((surname) => {
          return surname._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.surname.data is not an array:",
          state.surname.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteSurname.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = surnameSlice.actions;
export default surnameSlice.reducer;
